import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import { useCustomerPortalHashMap } from 'components/organisms/customer-portal/utils';

export const useQueryParams = () => {
  const location = useLocation();
  const val = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  return val;
};

export const useQueryParamsFromWindow = () => {
  const val = useMemo(() => new URLSearchParams(window.location.search), []);

  return val;
};

export const useTaskDrawerQueryParamsFromRouter = () => {
  const { hashMap, removeKey, pushToHashMap } = useCustomerPortalHashMap();

  const closeModal = useCallback(() => {
    removeKey('cp_task_drawer');
  }, [removeKey]);

  const taskDrawer = useMemo(() => {
    const td = hashMap?.cp_task_drawer;

    if (!td) {
      return {
        taskId: undefined,
        projectId: undefined,
      };
    }
    const [projectId, taskId] = td.split('.');

    return {
      taskId: parseInt(taskId, 10),
      projectId: parseInt(projectId, 10),
    };
  }, [hashMap]);

  const openTaskDrawer = useCallback(
    (projectId: number, taskId: number) => {
      pushToHashMap('cp_task_drawer', `${projectId}.${taskId}`);
    },
    [pushToHashMap],
  );

  return { taskDrawer, closeModal, openTaskDrawer };
};
